<template>
    <div v-if="!!record" class="card">
        <div class="card-header">
            <div class="card-title h5">
                {{ $root.translate("Xero") }}
                <span
                    v-if="!record.xero_oauth_url"
                    class="ml-4 text-small text-success"
                >
                    <open-icon
                        glyph="check-circle"
                        class="mr-2"
                    />
                    {{ $root.translate("Connected") }}
                </span>
            </div>
        </div>
        <div class="card-body text-center">
            <div v-if="!!record.xero_oauth_url">
                <base-link
                    :href="record.xero_oauth_url"
                    :title="$root.translate('Connect to your Xero Account')"
                    class="btn"
                >
                    {{ $root.translate("Connect") }}
                </base-link>
            </div>
            <div v-else>
                <slot>
                    <div class="form-group">
                        <default-button
                            :block="true"
                            :waiting="disconnecting"
                            color="error"
                            @click.prevent="disconnect"
                        >
                            {{ $root.translate("Disconnect") }}
                        </default-button>
                    </div>
                </slot>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import { DefaultButton, BaseLink, OpenIcon } from "@/nibnut/components"

export default {
    name: "XeroConnector",
    components: {
        DefaultButton,
        BaseLink,
        OpenIcon
    },
    methods: {
        disconnect () {
            this.disconnecting = true
            this.$store.dispatch("RECORD_ACTION", {
                entity: "setting",
                id: 1,
                action: "xero-disconnect",
                method: "put"
            }).then(() => {
                this.$router.go()
            }).catch(() => {
                this.disconnecting = false
            })
        }
    },
    props: {
        record: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            disconnecting: false
        }
    }
}
</script>
